<template>
  <TaskTypeForm @done="onDone"></TaskTypeForm>
</template>

<script>
import TaskTypeForm from 'CORE/components/task/type/form'

export default {
    name: 'NewTaskTypeView',
    components: {
        TaskTypeForm,
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'taskTypesList' })
        },
    },
}
</script>
